import { useState } from "react"
import { BrainIcon, ChevronDownIcon, LoaderCircleIcon } from "lucide-react"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"
import { cn } from "@/lib/utils"

export function ChatThinking({ text, active }: { text: string, active?: boolean }) {
  const [open, setOpen] = useState<boolean>()
  const shown = open ?? !!active

  return <Collapsible open={shown} onOpenChange={setOpen} className="text-xs text-muted-foreground">
    <CollapsibleTrigger className="flex items-center gap-1 hover:text-foreground">
      {active ? <LoaderCircleIcon className="size-3 animate-spin" /> : <BrainIcon className="size-3" />}
      {active ? "Thinking…" : "Thought"}
      <ChevronDownIcon className={cn("size-3 transition-transform", shown && "rotate-180")} />
    </CollapsibleTrigger>
    <CollapsibleContent>
      <p className="mt-1 max-h-48 overflow-auto whitespace-pre-wrap border-l-2 pl-2">{text}</p>
    </CollapsibleContent>
  </Collapsible>
}
